import { action } from 'typesafe-actions';

import * as types from './types';

export const fetchNewsPage = (page: number = 1) => action(types.FETCH_NEWS_PAGE, { page });
export const fetchNewsPageSuccess = (data: any) => action(types.FETCH_NEWS_PAGE_SUCCESS, data);
export const fetchNewsPageError = (error: any) => action(types.FETCH_NEWS_PAGE_ERROR, error);

export const fetchNews = (slug: string) => action(types.FETCH_NEWS, { slug });
export const fetchNewsSuccess = (data: any) => action(types.FETCH_NEWS_SUCCESS, data);
export const fetchNewsError = (error: any) => action(types.FETCH_NEWS_ERROR, error);
